import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo/LOGO.png";

export default function Footer() {
  return (
    <footer
      id="contact"
      className="relative bg-gradient-to-br from-maroon-dark via-maroon to-maroon-dark text-white pt-16 sm:pt-20 pb-8 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none opacity-[0.07]">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern
              id="footerPattern"
              width="40"
              height="40"
              patternUnits="userSpaceOnUse"
            >
              <circle cx="20" cy="20" r="1.5" fill="#c9a227" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#footerPattern)" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 pb-10 md:pb-12 border-b border-gold/20">
          <div>
            <img
              src={logo}
              alt="Shivkumar Jewellers"
              className="h-20 sm:h-24 w-auto object-contain mb-5"
            />
            <p className="text-sm text-white/70 leading-relaxed">
              Five generations of craftsmanship in pure 22K gold, silver and
              Rabari Ghat specialty  crafted with heart in Visnagar,
              Gujarat since 1933.
            </p>
            <a
              href="https://shivkumarjewellers.com"
              className="inline-block mt-3 text-xs text-gold hover:text-gold-light transition-colors"
            >
              shivkumarjewellers.com
            </a>
          </div>

          <div>
            <h4 className="font-serif text-gold text-base sm:text-lg font-semibold mb-4">
              Visit Us
            </h4>
            <div className="flex items-start gap-3 text-sm text-white/80">
              <svg className="flex-shrink-0 mt-0.5 text-gold" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <span>
                5/4/56, 57, 58 Swaminarayan Mandir
                <br />
                No Kancho, Lal Darwaja,
                <br />
                Visnagar, Gujarat  384315
              </span>
            </div>
            <div className="flex items-center gap-3 text-sm text-white/80 mt-3">
              <svg className="flex-shrink-0 text-gold" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              <span>Mon  Sat  10:00 AM to 9:00 PM</span>
            </div>
            <a
              href="tel:+919898313040"
              className="flex items-center gap-3 text-sm text-white/80 hover:text-gold mt-3 transition-colors"
            >
              <svg className="flex-shrink-0 text-gold" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              <span>+91 98983 13040</span>
            </a>
            <a
              href="mailto:smsgold.vs@gmail.com"
              className="flex items-center gap-3 text-sm text-white/80 hover:text-gold mt-3 transition-colors"
            >
              <svg className="flex-shrink-0 text-gold" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              <span className="break-all">smsgold.vs@gmail.com</span>
            </a>
          </div>

          <div>
            <h4 className="font-serif text-gold text-base sm:text-lg font-semibold mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2 text-sm">
              <FooterLink href="#home" label="Home" />
              <FooterLink href="#about" label="About Us" />
              <FooterLink href="#services" label="Why Us" />
              <FooterLink href="#catalogue" label="Collections" />
              <FooterLink href="#reels" label="Reels" />
              <FooterLink href="#visit" label="Contact Us" />
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-white/80 hover:text-gold transition-colors flex items-center gap-2"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-gold/60" />
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-white/80 hover:text-gold transition-colors flex items-center gap-2"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-gold/60" />
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-gold text-base sm:text-lg font-semibold mb-4">
              Enquiry Now
            </h4>
            <p className="text-sm text-white/70 mb-4">
              Reach out for bridal consultation, custom designs or any
              enquiry  we're here to help.
            </p>
            <div className="space-y-3 mb-5">
              <a
                href="tel:+919798993336"
                className="flex items-center gap-3 text-sm text-white bg-white/5 hover:bg-gold/20 transition-colors px-4 py-2.5 rounded-xl border border-gold/20"
              >
                <svg className="text-gold" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.25em] text-gold">
                    Call Enquiry
                  </div>
                  <div className="font-semibold">+91 97989 93336</div>
                </div>
              </a>
            </div>
            <p className="text-sm text-white/70 mb-3 font-semibold">
              Follow us
            </p>
            <div className="flex gap-3">
              <SocialBtn
                href="https://www.instagram.com/shivkumar_mangaldas_soni/"
                label="Instagram"
                icon={
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                  </svg>
                }
              />
              <SocialBtn
                href="https://wa.me/919898313040"
                label="WhatsApp"
                icon={
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                  </svg>
                }
              />
              <SocialBtn
                href="https://maps.app.goo.gl/UJEQ818wSSqJvhtE6"
                label="Google Maps"
                icon={
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                }
              />
              <SocialBtn
                href="https://www.justdial.com/Visnagar/Shivkumar-Mangaldas-Soni-Rabari-Vas/9999P2762-2762-230920220805-T5Z4_BZDET"
                label="Justdial"
                icon={
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polygon points="10 8 16 12 10 16 10 8" />
                  </svg>
                }
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-6 text-xs sm:text-sm text-white/60 text-center md:text-left">
          <div>
             {new Date().getFullYear()} Shivkumar Jewellers.
            All rights reserved.
          </div>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link
              to="/privacy-policy"
              className="hover:text-gold transition-colors"
            >
              Privacy
            </Link>
            <span className="opacity-30">|</span>
            <Link to="/terms" className="hover:text-gold transition-colors">
              Terms
            </Link>
          </div>
        </div>

        <div className="mt-5 pt-5 border-t border-gold/10 flex flex-col sm:flex-row items-center justify-center gap-2 text-xs text-white/50 text-center">
          <span>Designed & Developed by</span>
          <a
            href="https://www.shreepatisystems.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-gold hover:text-gold-light font-semibold tracking-wider transition-colors"
          >
            Shreepati Systems
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M7 17L17 7" />
              <path d="M7 7h10v10" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ href, label }) {
  return (
    <li>
      <a
        href={href}
        className="text-white/80 hover:text-gold transition-colors flex items-center gap-2"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-gold/60" />
        {label}
      </a>
    </li>
  );
}

function SocialBtn({ href, icon, label }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className="w-10 h-10 rounded-full border border-gold/40 text-gold hover:bg-gold hover:text-maroon transition-colors flex items-center justify-center"
    >
      {icon}
    </a>
  );
}
